import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { PaginateAuditorsActions as PaginateActions } from 'store/ducks/auditors';
import { usePaginationCache } from 'hooks';
import { Scaffold } from 'layouts';
import {
  AuditorsList,
  AuditorFilters,
  FindAuditors,
} from 'components/Pages/Auditors';
import { Paginator, ListingPageHeader, SettingsMenu } from 'components/Shared';
import * as S from './styles';

export const AuditorsListPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paginationCache, updatePaginationCache, handleFilter, handleSort } =
    usePaginationCache('auditors');

  const {
    data: auditors,
    pagination,
    loading,
  } = useSelector((state: RootState) => state.paginateAuditors);

  const [query, setQuery] = useState<FindAuditors>({
    search: '',
    page: 1,
    limit: 10,
    ...paginationCache,
  });

  const onPageChange = useCallback((page: number): void => {
    setQuery((state) => ({ ...state, page }));
  }, []);

  const onQueryChange = useCallback((): void => {
    dispatch(PaginateActions.request(query));
  }, [dispatch, query]);

  useEffect(() => {
    onQueryChange();
  }, [onQueryChange]);

  useEffect(() => {
    return () => {
      dispatch(PaginateActions.reset());
      updatePaginationCache(query);
    };
  }, [dispatch, query, updatePaginationCache]);

  return (
    <Scaffold>
      <SettingsMenu />
      <S.MainPanel>
        <ListingPageHeader
          icon={<S.CompanyIcon />}
          title="Fiscais"
          isLoading={loading}
          actions={
            <S.LinkButton to={'/configuracoes/fiscais/criar'} size="small">
              <S.PlusIcon /> Novo fiscal
            </S.LinkButton>
          }
        />
        <AuditorFilters
          currentFilter={query}
          onFilter={(filter) => handleFilter(query, filter, setQuery)}
        />
        <AuditorsList
          auditors={auditors}
          currentSort={query}
          onSort={(sort) => handleSort(query, sort, setQuery)}
        />
        <Paginator onPageChange={onPageChange} pagination={pagination} />
      </S.MainPanel>
    </Scaffold>
  );
};
